/** Facet tracing in the browser console. Set `window.FACETS_DEBUG = false` to turn off. */
function facetsLog(...e) {
  if ('undefined' != typeof window && !1 === window.FACETS_DEBUG) return;
  console.log('[facets]', ...e);
}

function facetsPreviewRequestUrl(form) {
  const section = FacetFiltersForm.getSections()[0],
    path = 'undefined' != typeof window ? window.location.pathname : '';
  if (!section || !form) return '(missing #product-grid section id or form)';
  let params = '';
  try {
    params = new URLSearchParams(new FormData(form)).toString();
  } catch (err) {
    return '(FormData error)';
  }
  return `${path}?section_id=${section.section}&${params}`;
}

class FacetFiltersForm extends HTMLElement {
  constructor() {
    super(),
      (this.onActiveFilterClick = this.onActiveFilterClick.bind(this)),
      (this.onFilterInputChange = this.onFilterInputChange.bind(this)),
      (this._onDelegatedClick = this._onDelegatedClick.bind(this)),
      (this.debouncedOnSubmit = debounce((e) => {
        this.onSubmitHandler(e);
      }, 300));
  }
  connectedCallback() {
    if (this._facetsListenersBound) return;
    (this._facetsListenersBound = !0),
      this.addEventListener('click', this._onDelegatedClick),
      this.addEventListener('change', this.onFilterInputChange);
    const e = this.querySelector('#FacetsWrapperDesktop');
    e && e.addEventListener('keyup', onKeyUpEscape);
  }
  disconnectedCallback() {
    this._facetsListenersBound &&
      ((this._facetsListenersBound = !1),
      this.removeEventListener('click', this._onDelegatedClick),
      this.removeEventListener('change', this.onFilterInputChange));
    const e = this.querySelector('#FacetsWrapperDesktop');
    e && e.removeEventListener('keyup', onKeyUpEscape);
  }
  _onDelegatedClick(e) {
    const t = e.target && e.target.closest && e.target.closest('.js-facet-submit');
    if (!t || !this.contains(t)) return;
    e.preventDefault(), facetsLog('apply button click (captured on <facet-filters-form>)', { className: t.className }), this.debouncedOnSubmit(e);
  }
  onFilterInputChange(e) {
    const t = e.target;
    if (!t || !t.matches || !t.matches('input[type="checkbox"]')) return;
    const n = t.form || this.querySelector('form');
    facetsLog('checkbox toggled (theme does not fetch yet — only after « apply » button)', {
      name: t.name,
      value: t.value,
      checked: t.checked,
      formId: n && n.id,
    }),
      facetsLog('same form state → next GET would look like:', facetsPreviewRequestUrl(n));
  }
  static setListeners() {
    window.addEventListener('popstate', (e) => {
      const t = e.state ? e.state.searchParams : FacetFiltersForm.searchParamsInitial;
      t !== FacetFiltersForm.searchParamsPrev && FacetFiltersForm.renderPage(t, null, !1);
    });
  }
  static toggleActiveFacets(e = !0) {
    document.querySelectorAll('.js-facet-remove').forEach((t) => {
      t.classList.toggle('disabled', e);
    });
  }
  static renderPage(e, t, r = !0) {
    FacetFiltersForm.searchParamsPrev = e;
    const i = FacetFiltersForm.getSections(),
      a = document.getElementById('ProductCount'),
      s = document.getElementById('ProductCountDesktop');
    facetsLog('renderPage', {
      searchParams: e || '(empty)',
      sectionIds: i.map((e) => e.section),
      pathname: window.location.pathname,
      updateHistory: r,
    }),
      a && a.classList.add('loading'),
      s && s.classList.add('loading'),
      i.forEach((r, a) => {
        const s = `${window.location.pathname}?section_id=${r.section}&${e}`,
          c = (e) => e.url === s;
        facetsLog('section request URL', s),
          FacetFiltersForm.filterData.some(c)
            ? FacetFiltersForm.renderSectionFromCache(c, t, a === i.length - 1)
            : FacetFiltersForm.renderSectionFromFetch(s, t, a === i.length - 1);
      }),
      r && FacetFiltersForm.updateURLHash(e);
  }
  static renderSectionFromFetch(e, t, r) {
    fetch(e)
      .then((t) => {
        facetsLog('fetch response', { url: e, status: t.status, ok: t.ok });
        return t.text();
      })
      .then((i) => {
        const a = i;
        facetsLog('fetch body', {
          charLength: a.length,
          hasProductGridContainer: a.includes('id="ProductGridContainer"'),
          hasProductCount: a.includes('id="ProductCount"'),
          hasFacetForm: a.includes('id="FacetFiltersForm"'),
        });
        if (
          ((FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html: a, url: e }]),
          FacetFiltersForm.renderFilters(a, t),
          FacetFiltersForm.renderProductGridContainer(a),
          FacetFiltersForm.renderProductCount(a),
          'function' == typeof initializeScrollAnimationTrigger && initializeScrollAnimationTrigger(a.innerHTML),
          r)
        ) {
          const e = new CustomEvent('facets:DOM:updated');
          document.dispatchEvent(e);
        }
      })
      .catch((t) => {
        console.error('[facets] fetch failed', { url: e, message: t && t.message, error: t });
        document.getElementById('ProductCount')?.classList.remove('loading');
        document.getElementById('ProductCountDesktop')?.classList.remove('loading');
      });
  }
  static renderSectionFromCache(e, t, r) {
    const i = FacetFiltersForm.filterData.find(e).html;
    if (
      (FacetFiltersForm.renderFilters(i, t),
      FacetFiltersForm.renderProductGridContainer(i),
      FacetFiltersForm.renderProductCount(i),
      'function' == typeof initializeScrollAnimationTrigger && initializeScrollAnimationTrigger(i.innerHTML),
      r)
    ) {
      const e = new CustomEvent('facets:DOM:updated');
      document.dispatchEvent(e);
    }
  }
  static renderProductGridContainer(e) {
    const t = document.getElementById('ProductGridContainer'),
      r = new DOMParser().parseFromString(e, 'text/html').getElementById('ProductGridContainer');
    t && r && (t.innerHTML = r.innerHTML);
  }
  static renderProductCount(e) {
    const t = new DOMParser().parseFromString(e, 'text/html').getElementById('ProductCount'),
      r = document.getElementById('ProductCount'),
      i = document.getElementById('ProductCountDesktop');
    t && r && ((r.innerHTML = t.innerHTML), r.classList.remove('loading'), i && ((i.innerHTML = t.innerHTML), i.classList.remove('loading')));
  }
  static renderFilters(e, t) {
    const r = new DOMParser().parseFromString(e, 'text/html'),
      i = r.querySelectorAll('#FacetFiltersForm .js-filter'),
      a = (e) => {
        const r = t ? t.target.closest('.js-filter') : void 0;
        return !!r && e.dataset.index === r.dataset.index;
      },
      s = Array.from(i).filter((e) => !a(e)),
      c = Array.from(i).find(a);
    s.forEach((e) => {
      const n = document.querySelector(`.js-filter[data-index="${e.dataset.index}"]`);
      n && (n.innerHTML = e.innerHTML);
    }),
      FacetFiltersForm.renderActiveFacets(r),
      FacetFiltersForm.renderAdditionalElements(r),
      c && t && FacetFiltersForm.renderCounts(c, t.target.closest('.js-filter'));
  }
  static renderActiveFacets(e) {
    ['.active-facets-mobile', '.active-facets-desktop'].forEach((t) => {
      const r = e.querySelector(t),
        i = document.querySelector(t);
      r && i && (i.innerHTML = r.innerHTML);
    }),
      FacetFiltersForm.toggleActiveFacets(!1);
  }
  static renderAdditionalElements(e) {
    ['.mobile-facets__open', '.mobile-facets__count', '.sorting'].forEach((t) => {
      const n = e.querySelector(t),
        i = document.querySelector(t);
      n && i && (i.innerHTML = n.innerHTML);
    });
  }
  static renderCounts(e, t) {
    if (!t) return;
    const r = t.querySelector('.facets__selected'),
      i = e.querySelector('.facets__selected'),
      a = t.querySelector('.facets__summary'),
      s = e.querySelector('.facets__summary');
    i && r && (t.querySelector('.facets__selected').outerHTML = e.querySelector('.facets__selected').outerHTML),
      a && s && (t.querySelector('.facets__summary').outerHTML = e.querySelector('.facets__summary').outerHTML);
  }
  static updateURLHash(e) {
    history.pushState({ searchParams: e }, '', `${window.location.pathname}${e && '?'.concat(e)}`);
  }
  static getSections() {
    const e = document.getElementById('product-grid');
    return e && e.dataset && e.dataset.id ? [{ section: e.dataset.id }] : [];
  }
  createSearchParams(e) {
    const t = new FormData(e),
      n = new URLSearchParams(t).toString();
    facetsLog('createSearchParams', { formId: e && e.id, queryString: n || '(empty)', keys: [...new Set([...t.keys()])] });
    return n;
  }
  onSubmitForm(e, t) {
    FacetFiltersForm.renderPage(e, t);
  }
  onSubmitHandler(e) {
    e.preventDefault();
    facetsLog('submit handler fired', {
      type: e.type,
      target: e.target && e.target.tagName,
      closestFormId: e.target && e.target.closest && e.target.closest('form') && e.target.closest('form').id,
    });
    const t = document.querySelectorAll('facet-filters-form form');
    if ('mobile-facets__checkbox' == e.srcElement.className) {
      const t = this.createSearchParams(e.target.closest('form'));
      facetsLog('mobile checkbox path → onSubmitForm', t), this.onSubmitForm(t, e);
    } else {
      const r = [],
        n = e.target && e.target.closest && e.target.closest('form'),
        i = n && 'FacetFiltersFormMobile' === n.id;
      facetsLog('forms in page (facet-filters-form)', { count: t.length, mobileMode: !!i }),
        t.forEach((e) => {
          i
            ? 'FacetFiltersFormMobile' === e.id && r.push(this.createSearchParams(e))
            : ('FacetSortForm' !== e.id && 'FacetFiltersForm' !== e.id && 'FacetSortDrawerForm' !== e.id) ||
              (document.querySelectorAll('.no-js-list').forEach((e) => e.remove()), r.push(this.createSearchParams(e)));
        }),
        facetsLog('combined query string passed to renderPage', r.join('&') || '(empty)'),
        this.onSubmitForm(r.join('&'), e);
    }
  }
  onActiveFilterClick(e) {
    e.preventDefault(), FacetFiltersForm.toggleActiveFacets();
    const t =
      -1 == e.currentTarget.href.indexOf('?') ? '' : e.currentTarget.href.slice(e.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(t);
  }
}
(FacetFiltersForm.filterData = []),
  (FacetFiltersForm.searchParamsInitial = window.location.search.slice(1)),
  (FacetFiltersForm.searchParamsPrev = window.location.search.slice(1)),
  customElements.define('facet-filters-form', FacetFiltersForm),
  FacetFiltersForm.setListeners();
class PriceRange extends HTMLElement {
  constructor() {
    super(),
      this.querySelectorAll('input').forEach((e) => e.addEventListener('change', this.onRangeChange.bind(this))),
      this.setMinAndMaxValues();
  }
  onRangeChange(e) {
    this.adjustToValidValues(e.currentTarget), this.setMinAndMaxValues();
  }
  setMinAndMaxValues() {
    const e = this.querySelectorAll('input'),
      t = e[0],
      r = e[1];
    r.value && t.setAttribute('max', r.value),
      t.value && r.setAttribute('min', t.value),
      '' === t.value && r.setAttribute('min', 0),
      '' === r.value && t.setAttribute('max', r.getAttribute('max'));
  }
  adjustToValidValues(e) {
    const t = Number(e.value),
      r = Number(e.getAttribute('min')),
      i = Number(e.getAttribute('max'));
    t < r && (e.value = r), t > i && (e.value = i);
  }
}
customElements.define('price-range', PriceRange);
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const e = this.querySelector('a');
    e.setAttribute('role', 'button'),
      e.addEventListener('click', this.closeFilter.bind(this)),
      e.addEventListener('keyup', (e) => {
        e.preventDefault(), 'SPACE' === e.code.toUpperCase() && this.closeFilter(e);
      });
  }
  closeFilter(e) {
    e.preventDefault(),
      (this.closest('facet-filters-form') || document.querySelector('facet-filters-form')).onActiveFilterClick(e);
  }
}
customElements.define('facet-remove', FacetRemove);
